import { render, staticRenderFns } from "./empty-list-default.vue?vue&type=template&id=b86afe3a&"
import script from "./empty-list-default.vue?vue&type=script&lang=js&"
export * from "./empty-list-default.vue?vue&type=script&lang=js&"
import style0 from "./empty-list-default.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports